<script>
    import R, {LOADER} from "../lib/requests";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import {sort, copyObjectData} from "../lib/lib";
    import PageHeader from "../components/PageHeader.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import TaxiModal from "./TaxiModal.svelte";

    let taxis = null;
    let taxiId = 0;
    let editId = null;

    const pageHeaderControls = [
        {id: 'create', name: 'CREATE TAXI', class: 'hidden-xs'},
        {id: 'create', name: '', icon: 'plus-circle', class: 'hidden-xl hidden-lg hidden-md hidden-sm'},
        {id: 'reload', name: '', icon: 'refresh'}
    ];

    const tableColumns = [
        {key: 'taxi_number', title: 'NUMBER', sortable: true, sort_way: 'ASC'},
        {key: 'licence_no', title: 'LICENCE NO', sortable: true},
        {key: 'transporter', title: 'TRANSPORTER', sortable: true, class: 'hidden-xs'},
        {key: '', title: ''},
    ];

    const load = () => {
        const onSuccess = result => {
            taxis = result;
        }

        const onFailure = err => {
        };

        R.handle(R.taxi.index, [], onSuccess, onFailure, LOADER.PAGE);
    }

    const onColumnSort = ({detail: column}) => {
        taxis = sort(taxis, column.key, column.sort_way === 'ASC');
    }

    const onCreate = () => {
        editId = 0;
    }

    const onEdit = (taxi) => {
        taxiId = taxi.id;
        editId = taxi.id;
    }

    const closeEdit = (taxi) => {
        if (taxi) {
            let item = taxis.find(x => x.id === taxi.id);
            if (!item) {
                taxis = [taxi, ...taxis];
            } else {
                copyObjectData(taxi, item);
                item.transporter = taxi.transporter;
            }
            taxis = taxis;
        }

        editId = null;
    }

    const onDelete = (taxi) => {
        Alert.delete("Delete Taxi", `This will permanently delete taxi "${taxi.licence_no}".\nAre you sure?`, () => deleteTaxi(taxi.id));
    }

    const deleteTaxi = (id) => {
        const onSuccess = result => {
            taxis = taxis.filter(x => x.id !== result);
            Notifier.showMessage("Taxi deleted");
        }

        const onFailure = err => {
            if (err.code) {
                if (err.code === 'object_related') {
                    let message = [];

                    Object.keys(err.params).map(key => {
                        if (err.params[key] > 0) {
                            message.push(`${err.params[key]} ${key}`);
                        }
                    });

                    Alert.warning("Delete taxi", `Taxi is associated with ${message.join(", ")}.\nYou can not delete this taxi.`);
                }
            }
        };

        R.handle(R.taxi.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    load();
</script>

<PageHeader title="Taxis" controls={ pageHeaderControls } on:create={ onCreate } on:reload={ load }/>

{#if taxis}
    <div class="panel">
        <div class="panel-body">
            {#if taxis.length}
                <table class="table table-list table-list-border">
                    <TableHeader {tableColumns} on:sort={ onColumnSort }/>
                    <tbody>
                    {#each taxis as item}
                        <tr class="row-hover pointer" class:row-selected="{ taxiId === item.id }"
                            on:click="{ () => onEdit(item) }">
                            <td>
                                <span class:not-active={ item.is_active < 1}>
                                    { item.taxi_number }
                                </span>
                            </td>
                            <td class="text-gray" on:click="{ () => onEdit(item) }">
                                { item.licence_no }
                            </td>
                            <td class="text-gray hidden-xs">
                                {#if item.transporter}
                                    { item.transporter.name }
                                {/if}
                            </td>
                            <td class="button-column pointer" title="delete taxi"
                                on:click|preventDefault|stopPropagation="{ () => onDelete(item) }">
                                <AppIcon icon="trash" size="16"/>
                            </td>
                        </tr>
                    {/each}
                    </tbody>
                </table>
            {:else}
                <div class="panel-pad">
                    <p>
                        There are no Taxis
                    </p>
                    <button class="btn btn-primary" on:click={ onCreate }>CREATE TAXI</button>
                </div>
            {/if}
        </div>
    </div>
{/if}
{#if editId != null}
    <TaxiModal taxiId="{ editId}" closeCallback="{ closeEdit }"/>
{/if}